// extracted by mini-css-extract-plugin
module.exports = {"root":"FilterClinic_root___xgl5"};